import React, { useEffect, useState } from 'react';
import { getStorage, ref, listAll, getDownloadURL, getMetadata } from 'firebase/storage';
import { storage } from './firebase';
import './Resources.css';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { db } from './firebase'; // assuming you have db exported from firebase.js
import { FaCopy, FaCheck } from "react-icons/fa"; // top of file

const getYouTubeEmbedURL = (url) => {
  if (!url) return '';
  const regExp = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/;
  const match = url.match(regExp);
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
};

const blogEntries = [
  { title: "The Networking Skilled Labor Gap: The realities and remedies", slug: "the-networking-skilled-labor-gap", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FBlogSkilledLabor.jpeg?alt=media&token=a6258f5f-6e1c-4616-8f6c-8c39eb65776c" },
  { title: "The Importance of Fiber Density in AI Data Centers", slug: "the-importance-of-fiber-density-in-ai-data-centers", image: "/images/services/image4.jpg" },
  { title: "What are VSFF connectors and why should you use them", slug: "what-are-VSFF-connectors-and-why-should-you-use-them", image: "/images/blog/MMC-Connector-Image.png" },
  { title: "Ask the expert: Your cable assembly questions answered by Go!Foton", slug: "cable-assembly-questions-answered", image: "/images/blog/cablesBlog.jpeg" },
]

const parseDateFromFilename = (name) => {
  // Pattern 1: MM.DD.YY or MM.DD.YYYY (e.g., 3.25.25 or 1.30.25)
  const dotDateMatch = name.match(/(\d{1,2})\.(\d{1,2})\.(\d{2,4})/);
  if (dotDateMatch) {
    const [_, m, d, y] = dotDateMatch;
    const year = y.length === 2 ? `20${y}` : y;
    return new Date(`${year}-${m}-${d}`);
  }

  // Pattern 2: Month name and Year (e.g., Sep 24 2025 or March 31 2025)
  const monthNames = "(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December)";
  const monthRegex = new RegExp(`${monthNames}\\s+\\d{1,2}\\s+\\d{4}`, 'i');
  const monthMatch = name.match(monthRegex);
  if (monthMatch) {
    return new Date(monthMatch[0]);
  }

  // Pattern 3: Just the Year (e.g., 2025, 2026) - last resort
  const yearMatch = name.match(/\b(20\d{2})\b/);
  if (yearMatch) {
    return new Date(`${yearMatch[0]}-01-01`); // Default to Jan 1st of that year
  }

  return null;
};

const formatCategoryName = (str) => {
  if (!str) return '';
  const withSpaces = str.replace(/([a-z])([A-Z])/g, '$1 $2'); // insert space before capital letters
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1); // capitalize first letter
};

// ADD: slug util + simple collision handler
const slugify = (str = '') =>
  str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const makeUniqueSlug = (base, taken) => {
  let slug = base;
  let i = 2;
  while (taken.has(slug)) {
    slug = `${base}-${i++}`;
  }
  taken.add(slug);
  return slug;
};




function Resources() {
  const [loading, setLoading] = useState(true);

  const [files, setFiles] = useState([]);
  const [activeFilter, setActiveFilter] = useState('Featured');
  const [filters, setFilters] = useState([]);
  const [previewKey, setPreviewKey] = useState(0);

  const [selectedFile, setSelectedFile] = useState(null);
const [gateOpen, setGateOpen] = useState(false);   // form gate modal
const [showPdf, setShowPdf] = useState(false);     // pdf modal after submit
const [submitting, setSubmitting] = useState(false);
const [success, setSuccess] = useState(false);
 const [copied, setCopied] = useState(false);

// ADD: fast lookup by slug
const [slugIndex, setSlugIndex] = useState(new Map()); // slug -> file


const [gateForm, setGateForm] = useState({
  firstName: '',
  companyName: '',
  companyEmail: '',
  phoneNumber: '',
  country: '',
  state: '',
  message: '',
});

useEffect(() => {
  if (loading) return;
  const docParam = getDocParam();
  if (!docParam) return;

  // Find the file by its exact URL (we encode when we set it)
  const decoded = decodeURIComponent(docParam);
  const match = files.find(f => f.url === decoded);

  if (match) {
    // If you want to keep your gate behavior, you can trigger gate here instead.
    setSelectedFile(match);
    setShowPdf(true);
    // Keep the URL (no need to push again). If you want to ensure no extra history entry:
    setDocParam(match.url, { replace: true });
  } else {
    // Optional: if the file isn’t in your list (e.g., the link is old),
    // you could gracefully ignore or attempt to open a bare viewer:
    // setSelectedFile({ name: 'Document', url: decoded, type: 'pdf', category: 'Unknown' });
    // setShowPdf(true);
  }
}, [loading, files]);

// When files load, open the doc from URL if present
useEffect(() => {
  if (loading) return;
  const docParam = getDocParam();
  if (!docParam) return;

  const decoded = decodeURIComponent(docParam);

  // Legacy link (full URL) support:
  const looksLikeUrl = /^https?:/i.test(decoded);
  let match = null;

  if (looksLikeUrl) {
    match = files.find(f => f.url === decoded);
  } else {
    // New: it's a slug
    match = slugIndex.get(decoded);
  }

  if (match) {
    setSelectedFile(match);
    setShowPdf(true);
    setDocParam(match.slug, { replace: true }); // ensure clean slug in URL
  }
}, [loading, files, slugIndex]);

useEffect(() => {
  const onPop = () => {
    const docParam = getDocParam();
    if (!docParam) {
      setSelectedFile(null);
      setShowPdf(false);
      return;
    }
    const decoded = decodeURIComponent(docParam);
    const looksLikeUrl = /^https?:/i.test(decoded);
    let match = null;

    if (looksLikeUrl) {
      match = files.find(f => f.url === decoded);
    } else {
      match = slugIndex.get(decoded);
    }

    if (match) {
      setSelectedFile(match);
      setShowPdf(true);
    }
  };

  window.addEventListener('popstate', onPop);
  return () => window.removeEventListener('popstate', onPop);
}, [files, slugIndex]);


// CHANGE: encode only the slug (still safe)
const encodeDocParam = (slug) => encodeURIComponent(slug);

// CHANGE: Extract ?doc=... (slug OR legacy encoded URL)
const getDocParam = () => {
  const sp = new URLSearchParams(window.location.search);
  return sp.get('doc'); // may be 'outside-plant-brochure' OR legacy encoded URL
};

// CHANGE: Push or replace ?doc=<slug>
const setDocParam = (slug, { replace = false } = {}) => {
  const url = new URL(window.location.href);
  if (slug) {
    url.searchParams.set('doc', encodeDocParam(slug));
  } else {
    url.searchParams.delete('doc');
  }
  if (replace) {
    window.history.replaceState(null, '', url.toString());
  } else {
    window.history.pushState(null, '', url.toString());
  }
};


const handleGateChange = (e) => {
  const { name, value } = e.target;
  setGateForm(prev => ({ ...prev, [name]: value }));
};


const handleView = (file) => {
  setSelectedFile(file);
  setShowPdf(true);
  setGateOpen(false);
  setDocParam(file.slug); // <-- use slug now
};


// submit gate form -> Monday -> then show PDF
const handleGateSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);
  setSuccess(false);

  try {
    const res = await fetch(
      "https://us-central1-gofoton-55796.cloudfunctions.net/submitResourceLead",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          formData: gateForm,
          resourceName: selectedFile?.name || "",
        }),
      }
    );

    const json = await res.json();

    if (!res.ok || !json.success) {
      throw new Error(
        json.error || "Submission failed."
      );
    }

    setSuccess(true);
    setGateOpen(false);
    setShowPdf(true);
  } catch (err) {
    console.error(err);
    alert(
      err.message ||
      "Submission failed."
    );
  } finally {
    setSubmitting(false);
  }
};

const handleClose = () => {
  setSelectedFile(null);
  setShowPdf(false);
  // remove ?doc= from the URL
  setDocParam(null);
};

useEffect(() => {
  const fetchFilesAndVideos = async () => {
    const baseRef = ref(storage);
    const folders = await listAll(baseRef);
    const excludedFolders = ['icons', 'other', 'stockImages', 'productImages', 'blogImages'];
    const allFiles = [];
    const taken = new Set();

    const featuredNames = [
      'Product Catalog',
      'Outside Plant Brochure',
      'Datacenter Brochure',
      'Decentralized Split Atchitecture White Paper',
      'Innovation story of PEACOC Technology'
    ];

    // 1. Fetch PDFs from Storage
    for (const folder of folders.prefixes) {
      if (excludedFolders.includes(folder.name)) continue;
      
      const items = await listAll(folder);

      // We use Promise.all here so we fetch all metadata/URLs for a folder in parallel
      const folderFiles = await Promise.all(
        items.items.map(async (item) => {
          const rawName = item.name.replace('.pdf', '').replace(/-/g, ' ');
          
          // Get URL and Metadata (which contains timeCreated)
          const [url, metadata] = await Promise.all([
            getDownloadURL(item),
            getMetadata(item)
          ]);

          const baseSlug = slugify(rawName);
          const slug = makeUniqueSlug(baseSlug, taken);

          const fileObj = {
            type: 'pdf',
            name: rawName,
            url,
            category: formatCategoryName(folder.name),
            slug,
            createdAt: parseDateFromFilename(rawName) || new Date(metadata.timeCreated),
          };

          return fileObj;
        })
      );

      allFiles.push(...folderFiles);

      // Handle Featured Duplication
      folderFiles.forEach(file => {
        if (featuredNames.includes(file.name)) {
          const featSlug = makeUniqueSlug(`${slugify(file.name)}-featured`, taken);
          allFiles.push({
            ...file,
            category: 'Featured',
            slug: featSlug,
            // createdAt is carried over automatically
          });
        }
      });
    }

    // 2. Fetch Videos from Firestore
    const videoDocs = await getDocs(collection(db, 'products'));
    const videoFiles = [];
    videoDocs.forEach(doc => {
      const data = doc.data();
      const videoFields = [
        { key: 'lds' }, { key: 'featuredContentVideo' }, { key: 'installationVideo' },
        { key: 'introVideo' }, { key: 'specialVideo1', titleKey: 'specialVideo1Title' },
        { key: 'specialVideo2', titleKey: 'specialVideo2Title' },
      ];

      videoFields.forEach(({ key, titleKey }) => {
        const videoUrl = data[key];
        if (videoUrl && typeof videoUrl === 'string') {
          const display = data[titleKey] || data.product || doc.id;
          const slug = makeUniqueSlug(slugify(display), taken);
          videoFiles.push({
            type: 'video',
            name: display,
            url: videoUrl,
            category: 'Videos',
            slug,
            createdAt: new Date(0), // Default old date for videos unless you have a field
          });
        }
      });
    });

    // 3. Process Blogs
    const blogDocs = await getDocs(collection(db, "documentMetadata"));

    const dynamicBlogFiles = blogDocs.docs
      .map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }))
      .filter((item) => item.type === "blog")
      .map((blog) => {
        const blogSlug = blog.slug || slugify(blog.title || blog.id);

        return {
          type: "blog",
          name: blog.title || "Untitled Blog",
          url: `/blog/${blogSlug}`,
          category: "Blogs",
          slug: makeUniqueSlug(blogSlug, taken),
          image: blog.image || "",
          createdAt: blog.date ? new Date(`${blog.date}T00:00:00`) : new Date(0),
        };
      });

    // Optional: keep old hardcoded blogs too, but put Firebase blogs first
    const staticBlogFiles = blogEntries.map(entry => ({
      type: "blog",
      name: entry.title,
      url: `/${entry.slug}`,
      category: "Blogs",
      slug: makeUniqueSlug(slugify(entry.slug || entry.title), taken),
      image: entry.image,
      createdAt: new Date(0),
    }));

    const blogFiles = [...dynamicBlogFiles, ...staticBlogFiles];

    // 4. Combine and Sort
    const combined = [...blogFiles, ...videoFiles, ...allFiles];

    combined.sort((a, b) => {
      const numberedRegex = /^[1-6]\./;
      const matchA = a.name.match(numberedRegex);
      const matchB = b.name.match(numberedRegex);

      // 1. Handle the "1-6" exception (Push to end)
      if (matchA && matchB) return parseInt(matchA[0]) - parseInt(matchB[0]);
      if (matchA) return 1;
      if (matchB) return -1;

      // 2. Sort by the parsed date (Most recent first)
      const dateA = a.createdAt.getTime();
      const dateB = b.createdAt.getTime();

      return dateB - dateA;
    });

    // 5. Update State
    const uniqueFilters = [
      'Featured',
      ...Array.from(new Set(combined.map(f => f.category)))
        .filter(c => c !== 'Featured' && c !== 'Blogs'),
      'Blogs'
    ];

    const idx = new Map();
    combined.forEach(f => idx.set(f.slug, f));

    setFiles(combined);
    setFilters([...uniqueFilters, 'All']);
    setSlugIndex(idx);
    setLoading(false);
  };

  fetchFilesAndVideos();
}, []);



const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener("resize", handleResize);
  console.log('isMobile?', isMobile)
  return () => window.removeEventListener("resize", handleResize);
}, []);

const [showBio, setShowBio] = useState(false)
const [activeBio, setActiveBio] = useState(false);




  const filteredFiles =
    activeFilter === 'All'
      ? files
      : files.filter((file) => file.category === activeFilter);

      const showBlogs = activeFilter === 'Blogs';


  return (
    
    <div className="contact-page">
      <div className="curved-header" style={{ background: isMobile ? '#8CC540' : ''}}>
        <center><h1 style={{ fontSize: isMobile ? '40px' : ''}}>Knowledge Center</h1></center>
      </div>

      <div className="filter-buttons">
        {filters.map((filter) => (
          <button
            key={filter}
            onClick={() => setActiveFilter(filter)}
            className={activeFilter === filter ? 'active' : ''}
          >
            {filter.charAt(0).toUpperCase() + filter.slice(1)}
          </button>
        ))}
      </div>

      {loading && (
        <div className="loading-container">
          <div><center>
      <div className="spinner"></div>
      <p style={{ marginTop: 20, color: '#4D4D4F' }}>Loading all documents. This may take a minute.</p>
      </center>
      </div>
    </div>
      )}

    <div className="document-grid">
      {filteredFiles.map((file, idx) => (
        <div className="document-card" key={idx}>
          {file.type === "blog" ? (
            <>
              {file.image && (
                <img
                  src={file.image}
                  alt={file.name}
                  className="blog-thumbnail"
                />
              )}

              <div className="document-title">{file.name}</div>

              <a
                className="cta-button"
                href={file.url}
                style={{ marginTop: 10 }}
              >
                Read
              </a>
            </>
          ) : file.type === 'video' ? (
            <>
              <div className="video-wrapper">
                {file.url.includes("youtu") ? (
                  <iframe
                    width="100%"
                    height="200"
                    src={getYouTubeEmbedURL(file.url)}
                    title={file.name}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="video-embed"
                  ></iframe>
                ) : (
                  <video
                    width="100%"
                    height="200"
                    controls
                    muted
                    preload="metadata"
                    onLoadedMetadata={(e) => {
                      const video = e.target;
                      video.currentTime = 1;
                    }}
                    poster="https://via.placeholder.com/300x200?text=Loading..."
                    className="video-embed"
                  >
                    <source src={file.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
              <div className="document-title">{file.name}</div>
            </>
          ) : (
            <>
              <div className="pdf-thumbnail-wrapper">
                <iframe
                  className="pdf-thumbnail"
                  src={`${file.url}#toolbar=0&navpanes=0&scrollbar=0&zoom=1`}
                  title={file.name}
                />
              </div>
              <div className="document-title">{file.name}</div>
              <button className="view-button" onClick={() => handleView(file)}>
                View
              </button>
            </>
          )}
        </div>
      ))}
    </div>




{gateOpen && (
  <div className="leadgate-overlay" role="dialog" aria-modal="true">
    <div className="leadgate-modal">
      <div className="leadgate-header">
        <h3>Tell us a bit about you</h3>
      </div>

      <form onSubmit={handleGateSubmit} className="leadgate-form">
        <div className="leadgate-grid">
          <div className="lg-field"><label>Name</label>
            <input name="firstName" value={gateForm.firstName} onChange={handleGateChange} required />
          </div>
          <div className="lg-field"><label>Company Name</label>
            <input name="companyName" value={gateForm.companyName} onChange={handleGateChange} required />
          </div>
          <div className="lg-field"><label>Company Email</label>
            <input type="email" name="companyEmail" value={gateForm.companyEmail} onChange={handleGateChange} required />
          </div>
          <div className="lg-field"><label>Phone Number (optional)</label>
            <input name="phoneNumber" value={gateForm.phoneNumber} onChange={handleGateChange} />
          </div>
          <div className="lg-field"><label>Country</label>
            <input name="country" value={gateForm.country} onChange={handleGateChange} required />
          </div>
          <div className="lg-field"><label>State</label>
            <input name="state" value={gateForm.state} onChange={handleGateChange} required />
          </div>
          <div className="lg-field lg-col-2"><label>Message</label>
            <textarea rows="4" name="message" value={gateForm.message} onChange={handleGateChange} />
          </div>
        </div>

        <button type="submit" className="leadgate-submit" disabled={submitting}>
          {submitting ? 'Submitting…' : 'Continue'}
        </button>
        <p className="leadgate-filename">Requesting: <strong>{selectedFile?.name}</strong></p>
      </form>
    </div>
  </div>
)}


{showPdf && selectedFile && (
  <div className="pdf-modal">
    <div className="pdf-modal-header">

<a
  className="share-btn"
  onClick={async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      alert("Failed to copy link");
    }
  }}
  style={{ display: "inline-flex", alignItems: "center", gap: "6px", marginLeft: 8 }}
>
  {copied ? <FaCheck size={14} /> : <FaCopy size={14} />}
  {copied ? "Copied" : "Copy"}
</a>


      <a
        href={selectedFile.url}
        target="_blank"
        rel="noreferrer"
        className="download-btn"
      >
        Download
      </a>
      <button className="close-btn" onClick={handleClose}>×</button>
    </div>

    <div className="pdf-preview-container">
      <embed
        src={`${selectedFile.url}#toolbar=0&navpanes=0&scrollbar=0&zoom=80`}
        type="application/pdf"
        width="90%"
        height="90%"
      />
    </div>
  </div>
)}



    </div>
  );
}

export default Resources;
